export const styles = () => ({
  img: {
    width: 300,
    height: 150,
    borderRadius: '8px 8px 0px 0px',
    backgroundColor: '#949494',
    backgroundPosition: '50% 50%',
    backgroundSize: 'cover',
  },
  text: {
    background: 'var(--color-white)',
    borderRadius: '0px 0px 8px 8px',
    padding: '6px 12px 12px',
    fontWeight: 300,
    width: 300,
  },
  textButtons: {
    background: 'var(--color-white)',
    padding: '6px 12px 12px',
    fontWeight: 300,
    width: 300,
  },
  subtitle: {
    background: 'var(--color-white)',
    borderRadius: '0px 0px 8px 8px',
    padding: '0px 12px 12px',
    fontWeight: 300,
    fontSize: 14,
    width: 300,
    color: '#828282',
  },
  subtitleButtons: {
    background: 'var(--color-white)',
    padding: '0px 12px 12px',
    fontWeight: 300,
    fontSize: 14,
    width: 300,
    color: '#828282',
  },
  link: {
    background: 'var(--color-white)',
    padding: '4px 12px',
    fontSize: 14,
    width: 300,
    display: 'block',
  },
  container: {
    border: '1px solid var(--color-platinum)',
    borderRadius: 8,
    height: 'fit-content',
  },
})
